import { render, staticRenderFns } from "./years.vue?vue&type=template&id=5c7c0df4&"
import script from "./years.vue?vue&type=script&lang=js&"
export * from "./years.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports